import React, { useEffect, useRef } from 'react'
import { useIsDomContentVisibleOnce } from '../../../hooks/useIsDomContentVisible'
import { StaticImage } from 'gatsby-plugin-image'

function Character({ isMobile }) {
  const imgProps = {
    className: 'character-img float-no-shadow-animation flicker-in',
    src: '../../../assets/images/home/character.png',
    alt: 'Personaje v-bot flotando ',
    role: 'img',
  }
  useEffect(() => {
    const onTimeoutCall = () => {
      let char = document.querySelector('.character-img.flicker-in')
      if (char) {
        char.classList.remove('flicker-in')
      }
    }
    let timeout = setTimeout(onTimeoutCall, 1000)
    return () => clearTimeout(timeout)
  }, [])
  if (isMobile) {
    return <StaticImage height={330} {...imgProps} placeholder="blurred" />
  }
  return <StaticImage height={618} {...imgProps} placeholder="blurred" />
}

function Vector({ type = 1 }: { type: number }) {
  const ref = useRef(null)
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (ref.current) {
        let elem = ref.current as HTMLElement

        elem.style.removeProperty('opacity')
        elem.classList.add('flicker-in')
        timeout = setTimeout(() => {
          elem.classList.remove('flicker-in')
          elem.classList.add('float-no-shadow-animation')
        }, 3100)
      }
    }, 1200)
    return () => clearTimeout(timeout)
  }, [])
  return (
    <div
      ref={ref}
      className={'vector    --type' + type}
      style={{ opacity: 0 }}
    ></div>
  )
}
function CharacterBase({ isMobile }) {
  const imgProps = {
    className: 'character-base',
    src: '../../../assets/images/home/base-character.png',
    alt: 'Base donde estan flotando nuestro personaje v-bot',
    role: 'img',
  }
  if (isMobile) {
    return <StaticImage height={92} {...imgProps} placeholder="blurred" />
  }
  return <StaticImage height={173} {...imgProps} placeholder="blurred" />
}

function courtainAnimation(elem: HTMLElement) {
  const maxW = elem.offsetWidth + 0
  let w = 1
  let speed = maxW / 100000
  elem.style.setProperty('height', elem.offsetHeight + 'px')
  elem.style.setProperty('width', '1px')
  return () => {
    if (w >= maxW) {
      elem.style.removeProperty('width')
      elem.style.removeProperty('height')
      return false
    }
    elem.style.setProperty('width', w + 'px')
    w += speed
    speed *= 1.06
    return true
  }
}

function CharConditionalContent({ isMobile }) {
  return (
    <>
      <div className="character-base-beam flicker-in " />
      <Character isMobile={isMobile} />
      <Vector type={1} />
      <Vector type={2} />
      <Vector type={3} />
      <div className="character_light"></div>
    </>
  )
}
export default function CharacterWrapper({ isMobile }) {
  const visible = useIsDomContentVisibleOnce('#v-bot-media-wrapper')
  return (
    <div id="v-bot-media-wrapper" className="character-v-bot">
      <div className="character-body-wrapper">
        {visible && <CharConditionalContent isMobile={isMobile} />}
      </div>
      <div className="character-base-wrapper">
        <CharacterBase isMobile={isMobile} />
      </div>
    </div>
  )
}
